import React from 'react';
import './checkout.style.sass';
import {
    Button, Col, Icon, Row, Badge, RadioGroup, Radio, Form, FormControl, FormGroup, ControlLabel, Schema
} from "rsuite";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import {selectCartItemCount, selectCartTotal, selectProduct} from "../../redux/users/users.selector";
import {AddProduct, ClearProduct, removeProduct} from "../../redux/users/users.actions";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import Header from '../../assets/image/CheckOutHeader.png';
import {selectPortal, selectPrice} from "../../redux/cart/cart.selector";
import {ChangePortal} from "../../redux/cart/cart.actions";
import Parsian from '../../assets/image/parsian.png';
import Saman from '../../assets/image/saman.png';
import {withRouter} from 'react-router-dom';
import {ChangeActiveLink} from "../../redux/site/site.actions";
import {calculatePrice, ConvertToPersianNumber} from "../../script";
import Axios from 'axios';
import {HandleErorr, Setting} from "../../setting";


class CheckoutLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formValue: {
                bank: 'saman',
                name: '',
                phone: '',
                products: '',
                address: ''
            },
            loading: false
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {history, product, ChangeActiveLink} = this.props;
        if (!product.length) {
            ChangeActiveLink('product');
            history.push('/product')
        }
    }

    handleSubmit = (value) => {
        const {formValue, loading} = this.state;
        if(value){
            this.setState({
                loading : true
            });
            Axios.post(`${Setting.apiUrl}api/payment/addProduct`, {
                    "phone" : `${formValue.phone}`,
                    "name" : `${formValue.name}` ,
                    "products" : formValue.products,
                    "address" : `${formValue.address}`,
                    "bank" : `${formValue.bank}`
                },
                {Accept: "application.json", contentType: "application.json"}
            )
                .then(res => {
                    if(res.data.bank === 'parsian'){
                        window.open(`${res.data.bankUrl}`)
                    } else if (res.data.bank === 'saman') {
                        document.getElementById('hide-form').innerHTML = res.data.form;
                        document.getElementById('samanpeyment').submit();
                    }
                }).catch(res => {
                    this.setState({
                        loading: false
                    });
                    HandleErorr(res)
                })
        }
    };

    render() {
        const {product, total, Clear, Remove, AddProduct, getPrice, ChangePortal, totlaOfAll} = this.props;
        const {loading} = this.state;
        const Title = ({title}) => {
            return (
                <div className='checkout-title'>
                    <span><Icon icon='circle'/><strong> {title}</strong></span>
                </div>
            )
        };
        const {StringType, NumberType, ArrayType} = Schema.Types;
        const model = Schema.Model({
            name: StringType().isRequired('نام خود را وارد کنید'),
            phone: NumberType()
                .isRequired('لطفا شماره تلفن خود را وارد کنید'),
            address: StringType().isRequired('آدرس خود را وارد کنید'),
            bank: StringType().isRequired('بانک وارد شود!'),
            products: ArrayType().isRequired('This field required')
        });
        const calculateTotal = (products) => {
            let lastPrice = 0;
            products.map(item =>{
                lastPrice += calculatePrice(item)
            })
            return ConvertToPersianNumber(lastPrice);
        }
        return (
            <div>
                <SubHeaderComponent imageSrc={Header} pageName='سبد خرید'/>
                <div className='checkout-container'>
                    <Form
                        formValue={this.state.formValue}
                        onChange={
                            (value) => {
                                let Value = value;
                                let products = [];
                                product.map(item => {
                                    products.push({
                                        id : item.id,
                                        quantity : item.quantity,
                                        productFor : item.productFor,
                                        install : item.install
                                    })
                                });
                                Value.products = products;
                                this.setState({
                                    formValue: Value
                                });
                            }
                        }
                        onSubmit={(value) => this.handleSubmit(value)}
                        model={model}
                    >
                        <Title title='مشخصات محصول'/>
                        {
                            product.map(item => {
                                return (
                                    <div key={item.id} className='checkout-item-div'>
                                        <div className='checkout-item-container'>
                                            <Row>
                                                <Col md={2} sm={4} xs={12}>
                                                    <div className='checkout-single-col'>
                                                        <Icon onClick={() => Clear(item)}
                                                              className='checkout-trash-icon'
                                                              icon='close-circle'/>
                                                    </div>
                                                </Col>
                                                <Col md={6} sm={11} xs={12}>
                                                    <div className='checkout-single-col'>
                                                        <div className='price-field'>
                                                            {
                                                                parseInt(item.offer) ?
                                                                    <Badge content={`% ${item.offer}`}>
                                                                        {console.log(item)}
                                                                        <h4>{ConvertToPersianNumber(calculatePrice(item))}</h4><strong
                                                                        style={{marginRight: '5px'}}>تومان</strong>
                                                                    </Badge> :
                                                                    <div>
                                                                        <h4>{ConvertToPersianNumber(calculatePrice(item))}</h4><strong
                                                                        style={{marginRight: '5px'}}>تومان</strong>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col md={4} sm={9} xs={12}>
                                                    <div className='checkout-single-col pick-quantity'>
                                                        <Row>
                                                            <Col xs={8}>
                                                                <Icon onClick={() => Remove(item)} icon='minus-square'/>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <span>{item.quantity}</span>
                                                            </Col>
                                                            <Col xs={8}>
                                                                <Icon onClick={() => AddProduct(item)}
                                                                      icon='plus-square'
                                                                      style={{right: '-5px'}}/>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                                <Col md={4} sm={8} xs={12}>
                                                    <div className='checkout-single-col checkout-item-image'>
                                                    </div>
                                                </Col>
                                                <Col md={8} sm={16} xs={24}>
                                                    <div className='checkout-single-col'
                                                         style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                                                        <h4>{item.name}</h4>
                                                        <span>
                                                        <span>{item.install ? "همراه با هزینه نصب" : "بدون هزینه نصب"}</span>
                                                        {item.type === 'vehicle' && <span> / </span>}
                                                        {
                                                            item.type === "vehicle" ? item.productFor === "inner" ? "خودرو داخلی" : "خودرو خارجی" : null
                                                        }
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className='checkout-factor-row'>
                            <Row>
                                <Col sm={12} xs={24} smPush={12}>
                                    <Title title='درگاه بانک'/>
                                    <div className='factor-col factor-portal'>
                                        <FormControl accepter={RadioGroup} inline name='bank'
                                                    style={{padding: '5px 10px'}}>
                                            <Radio value='saman'> <img src={Saman} alt='bank saman portal'/> بانک
                                                سامان</Radio>
                                            <Radio value='parsian'> <img src={Parsian} alt='bank parsian portal'/> بانک
                                                پارسیان</Radio>
                                        </FormControl>
                                    </div>
                                </Col>
                                <Col sm={12} xs={24} smPull={12}>
                                    <Title title='مجموع فاکتور'/>
                                    <div className='factor-col factor-factor'>
                                        <Row>
                                            <Col sm={14} xs={24}>
                                                <div className='factor-factor-div'>
                                                    <h3>
                                                    <span>
                                                        {calculateTotal(product)}
                                                        <small>تومان</small> </span>
                                                    </h3>
                                                </div>
                                            </Col>
                                            <Col sm={10} xs={24}>
                                                <div className='factor-factor-div'>
                                                    <h3>
                                                    <span>{totlaOfAll}
                                                        <small>عدد</small></span>
                                                    </h3>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className='checkout-form'>
                            <Title title='مشخصات تحویل گیرنده'/>

                            <div className='checkout-form-div'>
                                <Row>
                                    <Col md={6} sm={12} xs={24} mdPush={18} xsPush={48}>
                                        <FormGroup>
                                            <ControlLabel>نام و نام‌خانوادگی</ControlLabel>
                                            <FormControl name='name' placeholder='فارسی بنویسید'/>
                                        </FormGroup>
                                    </Col>
                                    <Col md={6} sm={12} xs={24} mdPush={6}>
                                        <FormGroup>
                                            <ControlLabel>تلفن همراه</ControlLabel>
                                            <FormControl name='phone' placeholder='با صفر وارد کنید'/>
                                        </FormGroup>
                                    </Col>
                                    <Col md={12} sm={24} xs={24} mdPull={12} xsPull={48}>
                                        <FormGroup>
                                            <ControlLabel>آدرس</ControlLabel>
                                            <FormControl name='address' placeholder='آدرس تحویل کالا'/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                            <Row style={{margin: '20px 0 30px'}}>
                                <Col lg={4} md={6} sm={8} xs={24}>
                                    <Button loading={loading} type='submit' className='Btn1' style={{width: '100%'}}>
                                        پرداخت
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Form>
                </div>
                <div id='hide-form' />
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    product: selectProduct,
    total: selectCartTotal,
    portal: selectPortal,
    totlaOfAll: selectCartItemCount,
    getPrice : selectPrice,
});

const mapDispatchToProps = dispatch => ({
    Clear: item => dispatch(ClearProduct(item)),
    Remove: item => dispatch(removeProduct(item)),
    AddProduct: item => dispatch(AddProduct(item)),
    ChangePortal: portal => dispatch(ChangePortal(portal)),
    ChangeActiveLink: link => dispatch(ChangeActiveLink(link))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckoutLayout));